import React from 'react'
import PropTypes from 'prop-types'
import SedaMetricSelectList from './SedaMetricSelectList'

const SedaMetricSelect = ({ onSelect, ...props }) => {
  return (
      <SedaMetricSelectList
        {...props}
      />
  )
}

SedaMetricSelect.propTypes = {
  onSelect: PropTypes.func
}

export default SedaMetricSelect